import HeaderPage from "@/components/layout/HeaderPage";
import Wrapper from "@/components/shared/Wrapper";
import SectionHeader from "@/components/shared/comman/requests/viewRequistiion/SectionHeader";
import * as Icons from "@/assets/features/requistion";
import AlertMessage from "@/components/shared/AlertMessage";

import ModificationSection from "../components/viewRequestModification/ModificationSection";
import OverallCommentsSection from "../components/viewRequestModification/OverallCommentsSection";
import UserInfoCard from "../components/viewRequestModification/UserInfoCard";
import FooterRequestionModification from "../components/viewRequestModification/FooterRequestionModification";
import { ConfirmationModal } from "@/components/shared/modals/ConfirmationModal";
import { useJobRequisitionStore } from "../store/useJobRequisitionStore";
import { VIEW_CANDIDATE_MODAL_KEYS } from "../constant/constant";

const ViewRequestModification = () => {
  const {setActionModal,actionModal,handleConfirmationClose}=useJobRequisitionStore()
  return (
    <div>
      <HeaderPage pageTitle="requisition management" />

      <Wrapper className="py-[2rem] px-[2.813rem]">
        <h1 className="text-lg font-semibold">View Requisition</h1>

        {/* User Info */}
        <SectionHeader
          icon={<Icons.BasicInformation className="w-6 h-6" />}
          title="Modification Request From"
        />

        <UserInfoCard />

        <AlertMessage
          type="info"
          icon={<Icons.Tooltip className="!w-4 !h-4" color="var(--color-primary)" />}
          className="bg-[#F1F5FC] text-secondary mt-6 text-sm"
          message="Please select at least one section that requires modification"
        />

        {/* --- Modification Sections --- */}
        <ModificationSection
          title="base salary range"
          subtitle="annual salary range for the position"
          current="40,000 - 80,000 EGP/month"
          recommended="40,000 - 80,000 EGP/month"
          showComment
          icon={<Icons.AI color="var(--color-primary)" />}
        />

        <ModificationSection
          title="years of experience"
          subtitle="Minimum required years of relevant experience"
          current="5+ years"
        />

        <ModificationSection
          title="technical details"
          subtitle="Required technical competencies"
          current="react, javascript, node js"
        />

        <ModificationSection
          title="education level"
          subtitle="Education requirements"
          current="Bachelor’s degree in computer science"
        />

        <ModificationSection
          title="skills required"
          subtitle="Required communication skills"
          current="commitment, self discipline, communication"
        />

        <ModificationSection
          title="years of experience"
          subtitle="Minimum required years of relevant experience"
          current="5+ years"
        />

        {/* Overall Comment Section */}
        <OverallCommentsSection />
      </Wrapper>
        <FooterRequestionModification/>

         <ConfirmationModal
                open={actionModal === VIEW_CANDIDATE_MODAL_KEYS.MODIFICATION_SUBMITTED_SUCCESS}
                onOpenChange={handleConfirmationClose}
                icon={<Icons.Done className="w-15 h-15" />}
                classNameFooter="!flex-col"
                title="your modification submitted Successfully"
                confirmLabel="back to requisition history"
               showCancel={false}
                onConfirm={handleConfirmationClose}
              />
    </div>
  );
};

export default ViewRequestModification;
